module.exports = __webpack_public_path__ + "img/2-7-4.9a7e0183.png";